import type { MouseEventHandler } from 'react';

export interface AnnouncementData {
  id: number;
  date: string;
  title: string;
  content: string | null;
}

export interface MtLandingBreederData {
  loading?: boolean;
  currentStep: number;
  currentProgress: number;
  onboardingStep: number;
  profileValidated?: boolean;
  hasAddedAnimals?: boolean;
  hasAddedLitters?: boolean;
  announcements?: AnnouncementData[];
  onCompleteProfileClick: MouseEventHandler;
  announcementsLoading: boolean;
  onLoadMoreAnnouncementsClick?: () => void;
  canLoadMoreAnnouncements: boolean;
  loadMoreAnnouncementsLoading: boolean;
}

export interface MtLandingBreederProps extends MtLandingBreederData {}
